import { render, staticRenderFns } from "./Administrateur.vue?vue&type=template&id=56c3b123&"
import script from "./Administrateur.vue?vue&type=script&lang=js&"
export * from "./Administrateur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports